module.exports = __webpack_public_path__ + "static/media/MHRP39N0003.ac061322.svg";